import { useLocation } from 'wouter';
import { getLenis } from './useLenis';

/**
 * Click handler for the header and footer logos.
 *
 * Clicking a link to the page you are already on is a no-op for the router, so
 * the logo did nothing on the home page. This scrolls to the top instead —
 * which is what people expect from a logo — and lets the router handle the
 * navigation normally from any other page.
 */
export function useLogoClick() {
  const [location] = useLocation();

  return (e: React.MouseEvent) => {
    if (location !== '/') return; // let wouter navigate

    e.preventDefault();
    const lenis = getLenis();
    if (lenis) lenis.scrollTo(0, { duration: 1.1 });
    else window.scrollTo({ top: 0, behavior: 'smooth' });
  };
}
